import clsx from 'clsx';
import { forwardRef, HTMLAttributes, useMemo } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  highlight?: boolean;
}

// A simple reusable card component with padding, rounded corners, and shadow.
export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ className = '', highlight = false, ...props }, ref) => {
    const highlightStyles = useMemo(() => {
      if (highlight) {
        return 'border-1 border-blue-500';
      }
      return 'border-1';
    }, [highlight]);

    return (
      <div
        ref={ref}
        className={clsx(
          'bg-white rounded-lg shadow-md p-8 ',
          highlightStyles,
          className,
        )}
        {...props}
      />
    );
  },
);

Card.displayName = 'Card';
